import * as React from 'react';
import RegionForm from "../../components/Regions/RegionForm/RegionForm";
var Region = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0440\u0435\u0433\u0438\u043E\u043D"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(RegionForm, null))))));
};
export default Region;



//////////////////
// WEBPACK FOOTER
// ./src/views/Regions/Region.tsx
// module id = 422
// module chunks = 0